// For <a href="tel:${phone}" /> situations
export const formatPhoneForLinks = (prefix, phone) => `${prefix}${phone}`.replace(/[^\d+]/g, '')
